import Preferences from './Preferences'
import './Preferences.scss'
export default Preferences
